const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['mattressfirm'] = {
        c: () => require('partner/themes/mattressfirm/mattressfirm.tsx'),
        $type: 'themeModule',
        da: [{name:'allVariants',  path:'data-actions/buybox-get-dimension-variants-availability-action', moduleName: 'buybox',runOn: 0},{name:'cardTypesState',  path:'data-actions/payment-cc-card-types.action', moduleName: 'checkout',runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', moduleName: 'buybox',runOn: 0},{name:'continueToPaymentState',  path:'data-actions/continue-to-payment-state-action', moduleName: 'checkout',runOn: 0},{name:'dimensionPrices',  path:'data-actions/buybox-get-dimension-pricing-action', moduleName: 'buybox',runOn: 0},{name:'disableSubmitOrderButton',  path:'data-actions/toggle-submit-order-button.action', moduleName: 'checkout',runOn: 0},{name:'listPageState',  path:'modules/mfrm-search-result-container/list-page-state', moduleName: 'breadcrumb',runOn: 0},{name:'mfrmCheckoutStepperState',  path:'data-actions/mfrm-checkout-stepper-state-action', moduleName: 'checkout',runOn: 0},{name:'navMenuState',  path:'data-actions/navigation-menu-state-data-action', moduleName: 'header',runOn: 0},{name:'payPalSuccessState',  path:'actions/paypalsuccesstrigger.action', moduleName: 'checkout',runOn: 0},{name:'paymentErrorState',  path:'data-actions/payment-error-state.action', moduleName: 'checkout',runOn: 0},{name:'productAttributes',  path:'data-actions/get-product-attributes-cartlines', moduleName: 'checkout',runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 0},{name:'progressiveLeasingModalState',  path:'data-actions/progressive-leasing-modal-state.action', moduleName: 'checkout',runOn: 0},{name:'redirectToOrderConfirmation',  path:'actions/payment-redirect-to-order-confirmation.action', moduleName: 'checkout',runOn: 0},{name:'selectedATPSlotInfo',  path:'data-actions/get-atp-dynamic-response', moduleName: 'checkout',runOn: 0},{name:'storeSelectorState',  path:'data-actions/store-selector-state-data-action', moduleName: 'buybox',runOn: 0},{name:'storeSelectorState',  path:'data-actions/store-selector-state-data-action', moduleName: 'header',runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', moduleName: 'buybox',runOn: 1},{name:'updateBreadcrumbOnSrp',  path:'actions/srp-breadcrumb-page.action', moduleName: 'breadcrumb',runOn: 0},{name:'updateDeliveryFeeCheckout',  path:'actions/get-delivery-fee-update.action', moduleName: 'checkout',runOn: 0},{name:'updateRecycleFeeCheckout',  path:'actions/get-recycle-fee-checkout.action', moduleName: 'checkout',runOn: 0},{name:'zipCodeValidityState',  path:'data-actions/checkout-zipcode-update-validity-action', moduleName: 'checkout',runOn: 0}],
        definitionExtensions: ['breadcrumb','buybox','checkout','content-block','footer-category','header','media-gallery','product-collection','promo-banner','search','spacer','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'mattressfirm',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'mattressfirm.theme.settings.json',
        md: 'src/themes/mattressfirm'
    });
        

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-delivery-fee-update.action';
            let dataAction = require('partner/actions/get-delivery-fee-update.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-recycle-fee-checkout.action';
            let dataAction = require('partner/actions/get-recycle-fee-checkout.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/payment-redirect-to-order-confirmation.action';
            let dataAction = require('partner/actions/payment-redirect-to-order-confirmation.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/paypalsuccesstrigger.action';
            let dataAction = require('partner/actions/paypalsuccesstrigger.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/srp-breadcrumb-page.action';
            let dataAction = require('partner/actions/srp-breadcrumb-page.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/buybox-get-dimension-pricing-action';
            let dataAction = require('partner/data-actions/buybox-get-dimension-pricing-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/buybox-get-dimension-variants-availability-action';
            let dataAction = require('partner/data-actions/buybox-get-dimension-variants-availability-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/checkout-zipcode-update-validity-action';
            let dataAction = require('partner/data-actions/checkout-zipcode-update-validity-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/continue-to-payment-state-action';
            let dataAction = require('partner/data-actions/continue-to-payment-state-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/get-atp-dynamic-response';
            let dataAction = require('partner/data-actions/get-atp-dynamic-response');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/get-product-attributes-cartlines';
            let dataAction = require('partner/data-actions/get-product-attributes-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/mfrm-checkout-stepper-state-action';
            let dataAction = require('partner/data-actions/mfrm-checkout-stepper-state-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/navigation-menu-state-data-action';
            let dataAction = require('partner/data-actions/navigation-menu-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/payment-cc-card-types.action';
            let dataAction = require('partner/data-actions/payment-cc-card-types.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/payment-error-state.action';
            let dataAction = require('partner/data-actions/payment-error-state.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/progressive-leasing-modal-state.action';
            let dataAction = require('partner/data-actions/progressive-leasing-modal-state.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/store-selector-state-data-action';
            let dataAction = require('partner/data-actions/store-selector-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/store-selector-state-data-action';
            let dataAction = require('partner/data-actions/store-selector-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/toggle-submit-order-button.action';
            let dataAction = require('partner/data-actions/toggle-submit-order-button.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'modules/mfrm-search-result-container/list-page-state';
            let dataAction = require('partner/modules/mfrm-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };